import { modalUserDetailStore } from '@/store'
import { ModalUserDetailInterface } from '@/store/ModalUserDetailStore'

export class ModalUserDetailService {
  public open(params: ModalUserDetailInterface) {
    modalUserDetailStore.open(params)
  }

  public close() {
    modalUserDetailStore.close()
  }
}
